import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        activeIndex: 0,
        dataset: {
            title: '',
            subtitle: ''
        },
        queryParam: ''
    },
    mutations: {
        setDataset(state, payload) {
            state.dataset = payload
        },
        setActiveIndex(state, payload) {
            state.activeIndex = payload
        },
        setQueryParam(state, payload) {
            state.queryParam = payload
        },
    },
    actions: {},
    plugins: [
        createPersistedState({
            key: 'spectrumAppState',
            paths: ['activeIndex', 'dataset', 'queryParam']
        })
    ]
})